import { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import { PortfolioListSet } from "../../../api/portfolio";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000001;
  width: 100vw;
  height: 100vh;

  .title {
    font-size: 2rem;
    margin-bottom: 30px;
    font-weight: 700;
    color: #3bb77e;
    text-align: center;
  }

  .desc {
    min-height: 80px;
    color: #5d5d5d;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1.3rem;
    margin-bottom: 20px;
    text-align: center;
    word-break: keep-all;
    & strong {
      font-weight: 300;
      color: black;
      background-color: #47e99f;
    }
  }

  .modal-section {
    position: fixed;
    top: 5vh;
    left: 25vw;
    width: 50vw;
    height: 90vh;
    background-color: white;
    overflow: auto;
    border: none;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    @media screen and (max-width: 991px) {
      top: 5vh;
      left: 5vw;
      width: 90vw;
      height: 90vh;
    }
    @media screen and (max-width: 575px) {
      left: 0vw;
      width: 100vw;
    }
  }

  .header {
    display: flex;
    padding: 10px 10px;
    & img {
      margin-left: auto;
      width: 35px;
      cursor: pointer;
    }
  }

  .modal-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: none;
    margin: 0 auto;
    overflow-y: auto;
    padding: 0px 36px 36px 36px !important;
    & > span {
      color: black;
    }
  }

  .ref_desc {
    font-size: 1rem;
    line-height: 1.2;
    color: #5a5a5a;
    margin-bottom: 20px;
    & strong {
      color: #202020;
      font-weight: 500;
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #f3f3f3;
      border-radius: 10px;
      padding: 20px;
      & span {
        display: flex;
        align-items: start;
        margin-bottom: 10px;
        word-break: keep-all;
        & img {
          margin-right: 10px;
        }
      }
    }
    .range {
      background-color: #d4e9df;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      & h6 {
        margin-right: 10px;
        color: #097e48;
      }
      & span {
        margin-bottom: 0;
      }
    }
  }
  .ref_title {
    margin: 30px auto 20px;
  }
`;

const ReferenceWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 15px;

  @media screen and (max-width: 575px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const SingleContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background-color: #fff;
  border: 1px solid #ececec;
  border-radius: 15px;
  overflow: hidden;
  transition: 0.2s;
  -moz-transition: 0.2s;
  -webkit-transition: 0.2s;
  -o-transition: 0.2s;
  :hover {
    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
    border: 1px solid #bce3c9;
    transition: 0.2s;
    -moz-transition: 0.2s;
    -webkit-transition: 0.2s;
    -o-transition: 0.2s;
  }
`;

export const SingleContentImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SingleContentImg = styled.img``;

const DesginReferenceModal = ({ handleReference, activeType }) => {
  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") return handleReference(activeType);
  };

  return (
    <>
      <ModalWrapper>
        <div className="modal-section">
          <div className="header">
            <img
              src="/assets/imgs/page/common/modal_close_icon.png"
              alt="modal_close_icon"
              onClick={() => handleReference(activeType)}
            />
          </div>
          <div className="modal-content">
            {/* 타이틀 */}
            <div className="title_desc">
              <h4 className="title">{activeType.title}</h4>
              <div className="desc_image_price_p">
                <div className="desc">{activeType.desc}</div>
              </div>
            </div>
            <div className="ref_desc">
              <div className="info">
                {activeType.referenceInfo.map((info, i) => (
                  <span key={i}>
                    <img
                      src="/assets/imgs/page/design/check_on.png"
                      alt="checkOn"
                    />
                    {info}
                  </span>
                ))}
                <div className="range">
                  <h6>작업범위</h6>
                  <span>{activeType.referenceRange}</span>
                </div>
              </div>
            </div>
            <h5 className="ref_title">
              {activeType.title} 디자인서비스 래퍼런스
            </h5>
            {/* 그리드 */}
            <ReferenceWrapper>
              {activeType.reference &&
                activeType.reference.length > 0 &&
                activeType.reference.map((url, i) => (
                  <SingleContentBox key={i}>
                    <SingleContentImgWrapper>
                      <SingleContentImg src={url} alt={url} />
                    </SingleContentImgWrapper>
                  </SingleContentBox>
                ))}
            </ReferenceWrapper>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};
export default DesginReferenceModal;
